import {toast} from 'react-toastify';

export const toastSuccessMessage = (content: string): ReturnType<typeof toast.success> => {
    return toast.success(content);
};

export const toastErrorMessage = (content: string): ReturnType<typeof toast.error> => {
    return toast.error(content);
};

export const toastWarningMessage = (content: string): ReturnType<typeof toast.warning> => {
  return toast.warning(content);
};

